import { Brazil } from "../../svg/brazil.svg";
import { USA } from "../../svg/usa.svg";

export const languageOptions = {
    english: { label: <USA />, value: "en" },
    portuguese: { label: <Brazil />, value: "ptBr" }
};